import type { CSSObject } from "type/tss";
import { baseColors } from "theme";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		section: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(3),
		},
		label: {
			fontSize: 16,
			fontWeight: 700,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
			marginBottom: theme.spacing(3),
		},
		// VPLAT 13: the App Market message sits under the Wix option, indented to its label.
		wixNotice: {
			display: "flex",
			gap: theme.spacing(1),
			// Indented to the option label: 24px radio + 16px gap.
			marginLeft: theme.spacing(5),
			padding: theme.spacing(2),
			borderRadius: 4,
			backgroundColor: baseColors.teal25,
		},
		wixNoticeIcon: {
			flexShrink: 0,
			marginTop: theme.spacing(0.5),
			color: theme.palette.custom.textPrimary,
		},
		wixNoticeBody: {
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-start",
			gap: theme.spacing(2),
		},
		wixInstall: {
			padding: 0,
			minWidth: 0,
		},
	} satisfies Record<string, CSSObject>);
};
